"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = window.WebSocket;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uploadcare/upload-client/lib/tools/sockets.browser.js
// module id = 1257
// module chunks = 68